module.exports = __webpack_public_path__ + "media/images/access/access-og-image-e59eee052bb7aacf6ec06f7c00107645.jpg";